import React from 'react';
import i18n from '../../../../i18n';
import swal from 'sweetalert';
import { HomeBanner } from '../../../home/homeBanner';
import { SideBar } from '../../components/Sidebar/Sidebar';
import NoData from '../../../common/NoData';
import { TableSkeleton } from '../../../common/skelton/TableSkelton';
import { auctionReject, getDeliveryAuctions } from './services/auctionApprovalServices';
import { tableStyles } from '../../../../styles/components/js/tableStyle';
import DataTable from 'react-data-table-component';
import { withRouter } from '../../../../hoc/withRouter';
import { WarningBox } from '../../../common/WarningBox';
import { CLIENT_PAYMENT_TYPE, DELIVERY_STATUS, DeliveryStatus } from '../../../../constants/status';
import StatusBadge from '../../../common/StatusBadge';
import '../../../../styles/pages/auction-approval-details.scss';
import AvatarIcon from '../../../common/AvatarIcon';
import { imageUrl } from '../../../../constants/global';
import { ConfirmModal } from '../../../common/ConfirmModal';
import { AuctionApproveModal } from './components/AuctionApproveModal';
import { swapWallet } from '../../../../models/auctionDelivery';
import { AuctionFundDeductModal } from './components/AuctionFundDeduct';
import { ArrowLeft } from 'lucide-react';
import { AuctionSettleModal } from './components/AuctionSettleModal';
import { getLoggedUser } from '../../../../state/user';

const user = getLoggedUser();

class AuctionApprovalDeatil extends React.Component {
  constructor() {
    super();
    this.state = {
      groupId: null,
      deliveryAuctions: [],
      meta: {
        organization: { name: '', image_url: null },
        group: {},
        total_records: 0,
        grand_total: 0,
      },
      selectedIds: [],
      selectedSum: 0,
      paymentApproval: {},
      is_loading: false,
      hideSidebar: false,
      limit: 15,
      page: 1,
    };
  }

  componentDidMount() {
    window.scrollTo(0, 0);
    const { groupId } = this.props.params;
    // Parse URL query params
    const params = new URLSearchParams(this.props.location.search);
    const status = params.get('status') || 'pending';
    const page = parseInt(params.get('page')) || 1;
    const limit = parseInt(params.get('limit')) || 15;

    this.setState({ groupId, status, page, limit }, () => {
      this.getDeliveryAuctions();
    });
  }

  // Update URL without refreshing page
  updateUrlQuery(q) {
    const queryString = new URLSearchParams(
      Object.fromEntries(Object.entries(q).filter(([_, v]) => v !== '' && v !== null))
    ).toString();
    const url = `/auction_approval/${this.state.groupId}?${queryString}`;
    window.history.replaceState(null, '', url);
  }

  isSwapDisabled(row) {
    if (!row) return true;

    const total = Number(row.total_amount) || 0;
    const client = Number(row.client_amount) || 0;
    const wallet = Number(row.wallet_amount) || 0;

    if (total <= 0) return true; // no valid total amount

    const remaining = total - client;

    // Swap disabled if:
    // 1. Remaining is 0 or negative
    // 2. Wallet balance is less than remaining
    if (remaining <= 0) return true;

    return wallet < remaining;
  }
  getColumns = () => {
    const { deliveryAuctions, selectedIds, status } = this.state;
    const hasFundAdded = deliveryAuctions.some(
      (row) => row.delivery_status === DeliveryStatus['fundAdded']
    );
    const hasCompleted = deliveryAuctions.some(
      (row) => row.delivery_status === DeliveryStatus['financeSettled']
    );
    let columns = [
      {
        name:
          (status === 'pending' && user.role === 'PM') ||
          (status === 'fundDeduct' && user.role === 'F') ? (
            <input
              type="checkbox"
              checked={
                deliveryAuctions.length > 0 &&
                selectedIds.length > 0 &&
                selectedIds.length === deliveryAuctions.length
              }
              onChange={() => this.handleCheckAll(deliveryAuctions)}
              aria-label="Select all eligible rows"
            />
          ) : null,
        cell: (row) =>
          (status === 'pending' && user.role === 'PM') ||
          (status === 'fundDeduct' && user.role === 'F') ? (
            <input
              type="checkbox"
              checked={selectedIds.includes(row.id)}
              onChange={() => this.handleCheckboxChange(row)}
              aria-label={`Select row ${row.id}`}
            />
          ) : null,
        width: '50px',
        ignoreRowClick: true,
        allowOverflow: true,
        button: true,
      },
      {
        id: 1,
        name: 'Sl No',
        sortable: true,
        wrap: true,
        width: '90px',
        cell: (row, i) => i + 1,
      },
      {
        id: 2,
        name: 'ID',
        sortable: true,
        wrap: true,
        width: '70px',
        cell: (row) => row.id,
      },
      {
        id: 3,
        minWidth: '100',
        name: i18n.t('auction'),
        cell: (row) => row.title,
      },
      {
        id: 4,
        minWidth: '130px',
        name: i18n.t('winner'),
        cell: (row) => (
          <div>
            <div>
              <strong>{row.winner}</strong>
            </div>
            <div style={{ fontSize: '14px', color: '#666' }}>Wallet: {row.wallet_amount ?? 0}</div>
            <div style={{ fontSize: '14px', color: '#666' }}>Client: {row.client_amount ?? 0}</div>
            {hasFundAdded && user.role === 'F' && (
              <button
                className="button-table"
                disabled={this.isSwapDisabled(row)}
                // onClick={() => this.setState({ showSwap: true, selectedRow: row })}
              >
                {i18n.t('swap')}
              </button>
            )}
          </div>
        ),
        wrap: true,
      },
      {
        id: 5,
        minWidth: '130px',
        name: i18n.t('bid_details'),
        wrap: true,
        cell: (row) => (
          <div>
            <div className="hitch">
              <strong>Bid:</strong> {row.bid_amount ?? 0}
            </div>
            <div className="hitch hitch-sub">
              <span>Service:</span> {row.service_charge ?? 0}
            </div>
            <div className="hitch hitch-sub">
              <span>Service VAT:</span> {row.vat_service_charge ?? 0}
            </div>
            <div className="hitch hitch-sub hitch-end">
              <span>Item VAT:</span> {row.item_amount_vat ?? 0}
            </div>
            <div className="hitch" style={{ fontWeight: 'bold', marginTop: '4px' }}>
              <span>Total:</span> {row.total_amount ?? 0}
            </div>
          </div>
        ),
      },
      {
        id: 6,
        name: i18n.t('delivery_status'),
        cell: (row) => <StatusBadge status={DELIVERY_STATUS[row.delivery_status]} />,
        wrap: true,
      },
    ];

    if (hasCompleted) {
      columns = [
        ...columns,
        {
          id: 7,
          name: i18n.t('invoice'),
          width: '120px',
          cell: (row) => (
            <button
              className="button-table"
              // onClick={() => handleDownload(row.id)} // pass auction/invoice ID
            >
              {i18n.t('download')}
            </button>
          ),
          wrap: true,
        },
        {
          id: 8,
          name: i18n.t('bank_info'),
          cell: (row) => (
            <div>
              <div>
                <strong>{row.bank_name ?? 'N/A'}</strong>
              </div>
              <div style={{ fontSize: '14px', color: '#666' }}>
                Ac No: {row.bank_account ?? 'N/A'}
              </div>
            </div>
          ),
          wrap: true,
        },
        {
          id: 9,
          name: i18n.t('fianance_doc'),
          width: '100px',
          cell: (row) => (
            <button
              className="button-table"
              // onClick={() => handleDownload(row.id)} // pass auction/invoice ID
            >
              {i18n.t('view')}
            </button>
          ),
          wrap: true,
        },
        {
          id: 10,
          name: i18n.t('finance_remarks'),
          cell: (row) => row.title,
        },
      ];
    }
    if (hasFundAdded) {
      columns = [
        ...columns,
        {
          id: 11,
          name: i18n.t('payment_type'),
          cell: (row) => <StatusBadge status={CLIENT_PAYMENT_TYPE[row.client_payment_type]} />,
          wrap: true,
        },
        ...(user.role === 'F'
          ? [
              {
                id: 12,
                name: i18n.t('action'),
                width: '130px',
                cell: (row) => (
                  <button
                    className="button-table"
                    onClick={() => this.setState({ showDeduct: true, selectedRow: row })}
                  >
                    {i18n.t('fund_deduct')}
                  </button>
                ),
              },
            ]
          : []),
      ];
    }

    return columns;
  };
  async getDeliveryAuctions() {
    this.setState({ is_loading: true });
    let { limit, page, status, groupId } = this.state;
    const queryStatus = status === 'all' ? null : status;
    const q = { page, limit, status: queryStatus };

    // Update URL
    this.updateUrlQuery(q);

    let response = await getDeliveryAuctions({ ...q, groupId });
    if (response.success) {
      let deliveryAuctions = response.data;
      let meta = response.meta;
      console.log(meta, 'meta');

      this.setState({
        deliveryAuctions,
        meta,
        is_loading: false,
      });
    }
    this.setState({ is_loading: false });
  }
  getMeta() {
    const { meta } = this.state;
    return {
      organizationName: meta?.organization?.name || 'N/A',
      totalAuctions: meta?.total_records || 0,
      totalAmount: meta?.grand_total || 0,
      organizationUrl:
        `${imageUrl}services/public/uploads/organization/${meta?.organization?.image_url}` || null,
    };
  }

  onChangePage = (page) => {
    console.log('page', page);

    this.setState({ page: page }, () => {
      this.getDeliveryAuctions();
    });
  };

  onChangeRowsPerPage = (limit) => {
    console.log('row', limit);
    this.setState({ limit: limit, page: 1 }, () => {
      this.getDeliveryAuctions();
    });
  };
  handleCheckboxChange = (row) => {
    this.setState((prev) => {
      const selectedIds = prev.selectedIds.includes(row.id)
        ? prev.selectedIds.filter((id) => id !== row.id)
        : [...prev.selectedIds, row.id];

      const selectedSum = this.state.deliveryAuctions
        .filter((auction) => selectedIds.includes(auction.id))
        .reduce((sum, auction) => sum + (auction.bid_amount || 0), 0);
      return { selectedIds, selectedSum };
    });
  };
  handleCheckAll = (payments) => {
    const paymentsIds = payments.map((r) => r.id);
    this.setState((prev) => {
      const allSelected = prev.selectedIds.length === paymentsIds.length;
      const selectedIds = allSelected ? [] : paymentsIds;

      // Calculate sum of selected bid_amounts
      const selectedSum = allSelected
        ? 0
        : payments.reduce((sum, payment) => sum + (payment.bid_amount || 0), 0);

      return { selectedIds, selectedSum };
    });
  };

  handleApprove = () => {
    this.setState({
      showApprove: true,
    });
  };
  handleFinanceSettlement = () => {
    const { meta, selectedIds, deliveryAuctions } = this.state;

    // Validate if items are selected
    if (!selectedIds.length) {
      swal('Warning', 'Please select at least one auction to proceed.', 'warning');
      return;
    }

    // Validate if meta.group exists
    if (!meta.group) {
      swal('Error', 'Group information is not available.', 'error');
      return;
    }

    // Get selected auctions for detailed calculations
    const selectedAuctions = deliveryAuctions.filter((auction) => selectedIds.includes(auction.id));

    // Calculate base totals from selected auctions
    const totals = selectedAuctions.reduce(
      (acc, auction) => {
        acc.bidAmount += Number(auction.bid_amount || 0);
        // Only include pre-calculated values if the corresponding flags are true
        acc.serviceCharge += meta.group.is_service_charge_included
          ? Number(auction.service_charge || 0)
          : 0;
        acc.itemAmountVat += meta.group.is_vat_included ? Number(auction.item_amount_vat || 0) : 0;
        acc.vatServiceCharge += meta.group.is_service_charge_vat_included
          ? Number(auction.vat_service_charge || 0)
          : 0;
        return acc;
      },
      {
        bidAmount: 0,
        serviceCharge: 0,
        itemAmountVat: 0,
        vatServiceCharge: 0,
      }
    );

    // Calculate total amount based on included components
    const totalAmount =
      totals.bidAmount + totals.serviceCharge + totals.itemAmountVat + totals.vatServiceCharge;

    // Handle service charge parsing (similar to PHP logic)
    const parseServiceCharge = (rawServiceCharge) => {
      if (!rawServiceCharge) return { value: 0, isPercent: false };

      const rawValue = String(rawServiceCharge);
      const isPercent = rawValue.includes('%');

      if (isPercent) {
        // Remove % and convert to number
        const numericValue = parseFloat(rawValue.replace('%', '')) || 0;
        return { value: numericValue, isPercent: true };
      } else {
        // Direct numeric value
        return { value: parseFloat(rawValue) || 0, isPercent: false };
      }
    };

    // Parse service charge from meta
    const serviceChargeInfo = parseServiceCharge(meta.group.service_charge);

    // Initialize paymentApproval object with conditional totals
    let paymentApproval = {
      bidAmount: Number(totals.bidAmount).toFixed(3),
      isServiceChargeIncluded: Boolean(Number(meta.group.is_service_charge_included || 0)),
      isServiceChargeVatIncluded: Boolean(Number(meta.group.is_service_charge_vat_included || 0)),
      isVatIncluded: Boolean(Number(meta.group.is_vat_included || 0)),
      clientName: meta.group.client_name || '',
      bankName: meta.group.bank_name || '',
      bankAccount: meta.group.bank_account || '',
      // Conditional calculations based on flags
      vat: meta.group.is_vat_included ? Number(totals.itemAmountVat).toFixed(3) : '0.000',
      serviceCharge: meta.group.is_service_charge_included
        ? Number(totals.serviceCharge).toFixed(3)
        : '0.000',
      vatServiceCharge: meta.group.is_service_charge_vat_included
        ? Number(totals.vatServiceCharge).toFixed(3)
        : '0.000',
      totalPayable: Number(totalAmount).toFixed(3),
      // Add group configuration for reference
      vatRate: meta.group.vat || '0',
      serviceChargeRate: meta.group.service_charge || '0%',
      serviceChargeValue: serviceChargeInfo.value,
      serviceChargeIsPercent: serviceChargeInfo.isPercent,
      selectedCount: selectedIds.length,
    };

    // Update state and show modal
    this.setState({
      paymentApproval,
      showSettlement: true,
    });
  };

  handleReject = () => {
    console.log('RR');
    this.setState({
      showReject: true,
    });
  };

  submitReject = async () => {
    const { selectedIds, rejectNote } = this.state;

    if (!rejectNote || rejectNote.trim() === '') {
      this.setState({ rejectNoteError: 'Reject note is required.' });
      return;
    }

    const payload = {
      selected_ids: selectedIds,
      reject_reason: rejectNote,
    };

    try {
      this.setState({ is_loading: true });

      const response = await auctionReject(payload);

      if (response && response.success) {
        swal(i18n.t('success'), i18n.t('auction_rejected'), 'success');
        this.setState(
          {
            showReject: false,
            selectedIds: [],
            selectedSum: 0,
            paymentApproval: {},
            rejectNote: null,
            is_loading: false,
          },
          () => {
            this.getDeliveryAuctions(); // refresh data after rejection
          }
        );
      } else {
        swal(i18n.t('failed'), response.message || 'Something went wrong', 'error');
        this.setState({ is_loading: false });
      }
    } catch (err) {
      console.error(err);
      this.setState({ is_loading: false });
      swal(i18n.t('failed'), 'Failed to reject auction(s)', 'error');
    }
  };

  handleCancel = () => {
    this.setState({
      showReject: false,
      selectedIds: [],
      selectedSum: 0,
      paymentApproval: {},
    });
  };

  handleCancelSwap = () => {
    this.setState({ showSwap: false, selectedRow: null });
  };

  submitSwap = async () => {
    const { selectedRow } = this.state;
    if (!selectedRow) return;

    this.setState({ action_loading: true });

    try {
      // Prepare data for API
      const payload = {
        auction: selectedRow.id,
        group: selectedRow.group_id,
        user: selectedRow.user_id,
        debit: selectedRow.total_amount,
        type: 'wallet_swap',
        status: 'F',
      };

      const response = await swapWallet(payload);
      if (response.success) {
        this.setState({
          showReject: false,
          selectedIds: [],
        });
        this.getDeliveryAuctions();
        swal(i18n.t('success'), i18n.t('data_loaded_successfully'), 'success');
      } else {
        swal(i18n.t('failed'), response.message || i18n.t('something_went_wrong'), 'error');
      }
    } catch (error) {
      console.error('Error fetching auctions:', error);
      swal(i18n.t('failed'), i18n.t('failed_to_load_data'), 'error');

      // Optionally show error toast/message
    } finally {
      this.setState({ action_loading: false });
    }
  };

  render() {
    const { deliveryAuctions, status, selectedIds, meta } = this.state;
    const { organizationName, organizationUrl, totalAuctions, totalAmount } = this.getMeta();

    return (
      <React.Fragment>
        <HomeBanner />
        <section className="mt-5">
          <div className="container">
            <div className="row">
              <div className="col-xl-3 col-lg-12 col-md-12">
                {!this.state.hideSidebar && <SideBar />}
              </div>
              <div
                className={
                  this.state.hideSidebar
                    ? 'col-xl-12 col-lg-12 col-md-12'
                    : 'col-xl-9 col-lg-12 col-md-12'
                }
              >
                <div className="card">
                  <div className="card-header">
                    <div className="expand-dashboard">
                      <span
                        style={{ fontSize: '1rem', marginRight: '0.5rem', cursor: 'pointer' }}
                        onClick={() => {
                          this.setState({
                            hideSidebar: !this.state.hideSidebar,
                          });
                        }}
                      >
                        {this.state.hideSidebar && <i className="icon-size-actual"></i>}
                        {!this.state.hideSidebar && <i className="icon-size-fullscreen"></i>}
                      </span>
                    </div>
                    {/* Back Button */}
                    <button
                      className="btn-back"
                      onClick={() =>
                        this.props.navigate(`/auction_approval?status=${this.state.status}`)
                      }
                    >
                      <ArrowLeft size={18} className="icon" />
                      <span>Back</span>
                    </button>
                  </div>
                  <div className="card-body">
                    <h3 className="card-title">{i18n.t('auction_details')}</h3>
                    <div className="page-header">
                      <div className="header-container">
                        <AvatarIcon
                          organizationName={organizationName}
                          avatarUrl={organizationUrl}
                          label="Client Name"
                        />

                        <div className="stats-section">
                          <div className="stat-box">
                            <div className="stat-label">Total Auctions</div>
                            <div className="stat-value">{totalAuctions}</div>
                          </div>

                          <div className="stat-box">
                            <div className="stat-label">Total Amount</div>
                            <div className="stat-value amount">{totalAmount.toFixed(3)}</div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div
                      className={`warning-box-wrapper ${
                        status === 'pending' && selectedIds.length > 0 ? 'open' : 'exit'
                      }`}
                    >
                      <WarningBox
                        data={selectedIds}
                        message="Auction approval Warning. Please confirm your action."
                        onApprove={() => this.handleApprove()}
                        onReject={() => this.handleReject()}
                      />
                    </div>
                    <div
                      className={`warning-box-wrapper ${
                        status === 'fundDeduct' && selectedIds.length > 0 ? 'open' : 'exit'
                      }`}
                    >
                      <WarningBox
                        data={selectedIds}
                        message="Payment Approval Warning. Please confirm your action."
                        onApprove={() => this.handleFinanceSettlement()}
                        approveText="Payment Approval"
                      />
                    </div>
                    <div className="Data-Listing">
                      {this.state.is_loading ? (
                        <TableSkeleton columns={6} rows={10} />
                      ) : deliveryAuctions.length ? (
                        <DataTable
                          responsive={true}
                          columns={this.getColumns()}
                          data={deliveryAuctions}
                          customStyles={tableStyles}
                          highlightOnHover
                          pagination
                          paginationServer
                          paginationTotalRows={this.state.total}
                          paginationPerPage={this.state.limit}
                          paginationDefaultPage={this.state.page}
                          paginationRowsPerPageOptions={[15, 25, 50, 100]}
                          paginationComponentOptions={{
                            rowsPerPageText: 'Groups per page:',
                            rangeSeparatorText: i18n.t('out'),
                          }}
                          onChangePage={this.onChangePage}
                          onChangeRowsPerPage={this.onChangeRowsPerPage}
                        />
                      ) : (
                        <NoData
                          message="No Auctions Available"
                          actionText="Refresh"
                          onAction={this.getDeliveryAuctions.bind(this)}
                        />
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        <AuctionApproveModal
          show={this.state.showApprove}
          selectedIds={this.state.selectedIds}
          onClose={() => this.setState({ showApprove: false })}
          onConfirm={(note) => this.handleApprove(note)}
          onSuccess={() => {
            this.setState({ showApprove: false, selectedIds: [], paymentApproval: {} }, () => {
              this.getDeliveryAuctions(); // refresh table after approve
            });
          }}
        />

        <ConfirmModal
          show={this.state.showReject}
          onClose={this.handleCancel}
          title={'Reject Confirmation'}
          message={'Are you sure you want to reject this item?'}
          onConfirm={this.submitReject}
          onCancel={this.handleCancel}
          confirmText={'Reject'}
          cancelText="Cancel"
          loading={this.state.action_loading}
        >
          <div className="reject-note-container">
            <p>Please provide the reason for rejecting the refund process.</p>
            <textarea
              id="rejectNote"
              value={this.state.rejectNote || ''}
              onChange={(e) => {
                const value = e.target.value;
                this.setState({
                  rejectNote: value,
                  rejectNoteError: value.trim() === '' ? 'Reject note is required.' : null,
                });
              }}
              placeholder="Enter reason for rejection"
              rows={3}
              className={`reject-note-textarea ${this.state.rejectNoteError ? 'is-invalid' : ''}`}
            />
            {this.state.rejectNoteError && (
              <p className="error-text">{this.state.rejectNoteError}</p>
            )}
          </div>
        </ConfirmModal>

        <ConfirmModal
          show={this.state.showSwap}
          onClose={this.handleCancelSwap}
          title={'Wallet Swap Confirmation'}
          message={'Are you sure you want to swap this amount from the wallet?'}
          onConfirm={this.submitSwap}
          onCancel={this.handleCancelSwap}
          confirmText={'Swap'}
          cancelText="Cancel"
          loading={this.state.action_loading}
        ></ConfirmModal>

        <AuctionFundDeductModal
          show={this.state.showDeduct}
          auction={this.state.selectedRow}
          onClose={() => this.setState({ showDeduct: false })}
          onConfirm={(note) => this.handleApprove(note)}
          onSuccess={() => {
            this.setState({ showDeduct: false, selectedRow: null }, () => {
              this.getDeliveryAuctions();
            });
          }}
        />

        <AuctionSettleModal
          show={this.state.showSettlement}
          selectedIds={this.state.selectedIds}
          paymentApproval={this.state.paymentApproval}
          group={meta.group || {}}
          onClose={() => this.setState({ showSettlement: false })}
          onConfirm={(note) => this.handleFinanceSettlement(note)}
          onSuccess={() => {
            this.setState(
              {
                showSettlement: false,
                selectedIds: [],
                selectedSum: 0,
                paymentApproval: {},
                deliveryAuctions: [],
              },
              () => {
                this.getDeliveryAuctions(); // refresh table after approve
              }
            );
          }}
        />
      </React.Fragment>
    );
  }
}
export default withRouter(AuctionApprovalDeatil);
